import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { CommonModule, NgFor, NgIf, NgOptimizedImage } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDrawer, MatSidenavModule } from "@angular/material/sidenav";
import { Subject, Subscription, takeUntil } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from "moment";
import { DynamicSettingsService } from "app/layout/common/dynamic-settings/dynamic-settings.service";
import { ModalComponent } from "app/modules/shared/modal.component";
import { ModalService } from "app/_services/modal.service";
import { DynamicFormComponent } from "app/modules/shared/forms/dynamic-form/dynamic-form.component";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UserService } from "app/core/user/user.service";
import { fuseAnimations } from "@fuse/animations";
import { cloneDeep } from "lodash";
import { KeyPairsComponent } from "app/modules/shared/key-pairs/key-pairs.component";
import { GridsComponent } from "app/modules/shared/grids/grids.component";
import { TableComponent } from "app/modules/shared/table/table.component";
import { FuseScrollbarDirective } from "@fuse/directives/scrollbar";
import { MaterialModule } from "app/material.module";
import { AppFilterPipeModule } from "app/_filters/app.filter-pipe.module";
import { FuseAlertComponent } from "@fuse/components/alert";
import { CommonService } from "app/_services/common.service";
import { LoaderService } from "app/_services/loader.service";
import { BaseRequestService } from "app/_services/base.service";
import { MyToastrService } from "app/_services/toastr.service";

const moment = _rollupMoment || _moment;

@Component({
  selector: "app-partner-audit",
  standalone: true,
  imports: [
    CommonModule,
    GridsComponent,
    KeyPairsComponent,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    ModalComponent,
    TableComponent,
    FuseScrollbarDirective,
    MaterialModule,
    AppFilterPipeModule,
    DynamicFormComponent,
    FuseAlertComponent,
    NgIf,
    NgFor,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: "./partner-audit.component.html",
  styleUrls: ["./partner-audit.component.scss"],
})
export class PartnerAuditComponent {
  @ViewChild("drawer") drawer: MatDrawer;
  drawerPosition: "start" | "end" = "end";
  drawerMode: "over" | "side" = "side";
  drawerOpened: boolean = false;
  cAsset: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  deviTableOptions: any = {};

  companyId: any;
  private subs: Subscription;
  private site: Subscription;
  addAsset: any = {};
  scanAsset: any = {};
  importance: any = [
    { key: "Low", value: "25" },
    { key: "Medium", value: "50" },
    { key: "High", value: "75" },
    { key: "Critical", value: "100" },
  ];
  formElements: any = [
    {
      name: "name",
      description: "Name",
      example: "",
      min: 3,
      max: 25,
      required: true,
      schema: {
        type: "text",
      },
    },
    {
      name: "ip",
      description: "Asset IP",
      example: "",
      min: 3,
      max: 25,
      required: true,
      condition: "ip",
      schema: {
        type: "ip",
      },
    },
    {
      name: "importance",
      description: "Choose Importance",
      required: true,
      options: this.importance,
      schema: {
        type: "dropdown",
      },
    },
  ];
  scanTypeList = [
    { key: "Full Scan", value: 1 },
    { key: "Asset Scan", value: 2 },
    { key: "Active Directory Scan", value: 5 },
    { key: "SNMP Scan", value: 6 },
    { key: "LightWeight Agent Scan", value: 7 },
    { key: "Firewall Scan", value: 8 },
    { key: "PII Scan", value: 9 },
  ];
  addformElements = [];
  scanformElements: any;
  formScanElements: any = [
    {
      name: "scan_type",
      description: "Scan Type",
      example: "",
      required: true,
      searching: false,
      options: [
        { displayName: "Full Scan", value: "FULLSCAN" },
        { displayName: "Active Directory Scan", value: "ADSCAN" },
        { displayName: "Network Scan", value: "NETWORKSCAN" },
      ],
      schema: {
        type: "dropdown",
        key: "displayName",
        value: "value",
      },
    },
  ];
  suppressData: any = {};
  internalUsers: any = [];

  fromDate = new Date();
  fromMinEndDate: any = null;
  currentUser: any = "";
  reasonsList: string[] = [
    "Justified for business reasons",
    "False Positive",
    "Compensating control in place",
    "Other",
  ];
  /**
   * Constructor
   */
  constructor(
    private cs: CommonService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private _ds: DynamicSettingsService,
    private _bs: BaseRequestService,
    public _modalService: ModalService,
    public _userService: UserService,
    private toast: MyToastrService,
    public confirmDialog: FuseConfirmationService
  ) {
    this.subs = this._ds.assetEmitter.subscribe((res: any) => {
      if (res.target === "new-asset") {
        this.addformElements = [];
        // this.addNewAsset();
      }
      if (res.target === "remove-asset") {
        if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
          // this.deleteAsset(this.cs.selectedTableRows);
        } else {
          this.toast.sToast("info", "Please select at least one asset.");
        }
      }
      if (res.target === "scan-asset") {
        if (
          (this.cs.selectedTableRows && this.cs.selectedTableRows.length) ||
          (this.cAsset && this.cAsset.id)
        ) {
          // this.scanAssetNow();
        } else {
          this.toast.sToast("info", "Please select at least one asset.");
        }
      }
      if (res.target === "deprecate-asset") {
        if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
          // this.deprecateRestoreAsset(this.cs.selectedTableRows, true);
        } else {
          this.toast.sToast("info", "Please select at least one asset.");
        }
      }
      if (res.target === "restore-asset") {
        if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
          // this.deprecateRestoreAsset(this.cs.selectedTableRows, false);
        } else {
          this.toast.sToast("info", "Please select at least one asset.");
        }
      }
    });
    this.site = this.cs.selectedSiteChanged.subscribe((res) => {
      if (this.drawer.opened) {
        this.drawer.toggle().then((r) => console.log(r));
      }
    });
    try {
      this.route.data.subscribe((v: any) => {
        this.deviTableOptions = {
          columns: [
            {
              header: "Action",
              columnDef: "action",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.action}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Action By",
              columnDef: "action_by",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.action_by}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Tenant Name",
              columnDef: "tenant_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.tenant_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              "header": "Status",
              align: "center",
              "columnDef": "status",
              "filter": "",
              "cell": "(element: any) => `${element.status}`",
              "order": 0,
              "visible": true,
              "isToolTip": false,
              "isToolTipCol": "",
              "hasMultiData": false,
              "isHyperlink": false,
              "class": "",
              "color": "",
              "isProgressCntrl": false,
              "isColoredCntrl": false,
              "colList": [],
              "isfaicon": false,
              "isAddingText": false,
              "addingText": "",
              "img": false,
              "imgPath": "",
              "isSort": true,
              "iscolumnSearch": false,
              statusicon: true,
              success: "true",
              failure: "false",
              successIconPath: '/assets/images/auditLogins/tick.svg',
              successToolTip: 'True',
              failureIconPath: '/assets/images/auditLogins/cross.svg',
              failureToolTip: 'False',
          },
            {
              header: "Reason",
              columnDef: "reason",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.reason}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Created On",
              columnDef: "created",
              cType: "string",
              filter: "utcToLocale",
              cell: "(element: any) => `${element.created}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
          ],
          sortOptions: { active: "created", direction: "desc" },
          _pageData: [],
          tableOptions: {
            title: "Audit Logs",
            isServerSide: false,
            selectText: "auditlogs(s)",
            loading: true,
            floatingFilter: true,
            rowSelection: false,
            showAction: false,
            actionMenuItems: [],
            pagination: true,
            pageOptions: [5, 10, 25, 100],
            pageSize: 10,
            search: false,
            saveData: true,
            showhideList: true,
            refreshData: true,
            showFilter: true,
            showTagFilter: false,
            exportExcel: true,
            add: false,
            columnSearch: false,
            compareData: false,
            filterDownload: false,
            serverSide: {
              url: "/r/report_queries/audit_logs_view",
              condition: `true`,
              type: "get",
            },
          },
          changeValue: new Subject<any>(),
        };
      });
    } catch (error) {
      console.error("Error retrieving route data:", error);
    }
  }

  ngOnInit(): void {
    // this.getAsset(this.route.snapshot.paramMap.get("id"));
    this._userService.userd$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((user: any) => {
        this.currentUser = user["email"];
      });
    this.scanformElements = this.cs.processFormElements(this.formScanElements);
  }

   
}
